import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';

import {
  WORK_ORDER_STOCK_TRANSFER_CACHE_PAYLOAD_VERSION,
  WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE,
} from './constants';
import { parseFormCacheEnvelope } from './parseEnvelope';

/**
 * POST /system/form-cache/{scope}/start-new
 * 僅 null／expired／CONSUMED 時重建；ACTIVE 已存在 → 409 conflict。
 * @param {{ payload: object, payloadVersion?: number }} body
 * @param {string} [scope]
 */
export async function startNewFormCache(
  { payload, payloadVersion },
  scope = WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE,
) {
  const { data: raw } = await request.post(
    `/system/form-cache/${scope}/start-new`,
    keysToSnake({
      payloadVersion:
        payloadVersion ?? WORK_ORDER_STOCK_TRANSFER_CACHE_PAYLOAD_VERSION,
      payload,
    }),
  );
  return parseFormCacheEnvelope(raw);
}
